const parameters = {
	HOME_URL: '/apps/dashboard',
	HOME_URL2: '/dashboard'
};

module.exports = parameters;
